/* eslint-disable import/prefer-default-export */
import request from '../utils/request';
import { exportExcel } from '../utils/tools';

// 获取电子发票列表
export const invoiceGridList = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceList/invoiceGrid',
  method: 'post',
  data,
});

// 红冲
export const invoiceRed = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceList/invoiceRed',
  method: 'post',
  data,
});

// 获取二维码信息
export const getQrcodeInfo = (params) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceList/searchQrFL',
  method: 'get',
  params,
});

// 导出开票记录
export const exportExcelRecords = (params) => exportExcel({
  url: '/pubs/manage/eInvoice/webApi/einvoiceList/export',
  params,
});

// 作废
export const invoiceCancel = (data) => request({
  url: '/pubs/manage/eInvoice/webApi/einvoiceList/invoiceCancel',
  method: 'post',
  data,
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sditest/electronic-invoice-api/src/api/electronicInvoice.js
// module id = MgQ5
// module chunks = 70